// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deck-global-left-nav {
  -webkit-font-smoothing: antialiased;
}
.deck-global-left-nav .nkl-deck-left-nav-primary {
  opacity: 0;
  transform: translateX(-50%);
  transition: all 250ms ease-out;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
.deck-global-left-nav .nkl-deck-left-nav-secondary {
  opacity: 0;
  transform: translateX(-75%);
  transition: all 300ms ease-out;
}
.deck-global-left-nav.is-loaded .nkl-deck-left-nav-primary,
.deck-global-left-nav.is-loaded .nkl-deck-left-nav-secondary {
  opacity: 1;
  transform: translateX(0);
  border: none;
}
.deck-global-left-nav .close-icon {
  display: none;
}
@media screen and (max-width: 735px) {
  .deck-global-left-nav .close-icon {
    display: flex;
    margin-top: 6px;
    width: 100%;
    justify-content: flex-end;
    margin-bottom: 11px;
    color: #59606D;
  }
  .deck-global-left-nav .close-icon svg {
    cursor: pointer;
    margin-right: 30px;
  }
}
.nkl-deck-left-nav-primary.ant-menu {
  padding-bottom: 60px;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item {
  font-size: 16px;
  font-weight: 400;
  border-radius: 6px;
  margin: 0;
  padding: 14px;
  line-height: 24px;
  text-transform: capitalize;
  margin-bottom: 8px;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item.disabled {
  color: #b1baca;
  cursor: not-allowed;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item:hover {
  background-color: #F5F7FA;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item.ant-menu-item-selected {
  background-color: #F5F7FA;
  font-weight: 700;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item svg {
  min-width: 24px;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item .ant-menu-title-content {
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item {
  padding-left: 0;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item .ant-menu-submenu-title {
  margin-inline: 0;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item .ant-menu-submenu-title .ant-menu-title-content {
  font-weight: 400;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item.ant-menu-submenu-selected .ant-menu-submenu-title {
  color: black;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-title-content {
  font-weight: 700;
}
.nkl-deck-left-nav-secondary.ant-menu .ant-menu-item.menu-item {
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  border-radius: 4px;
  margin: 0;
  padding: 10px 14px;
}
`, "",{"version":3,"sources":["webpack://./src/deck/left-nav/left-nav.less"],"names":[],"mappings":"AAEA;EACI,mCAAA;AADJ;AAAA;EAIQ,UAAA;EACA,2BAAA;EACA,8BAAA;EACA,mKAAA;AADR;AANA;EAWQ,UAAA;EACA,2BAAA;EACA,8BAAA;AAFR;AAKI;;EAIQ,UAAA;EACA,wBAAA;EACA,YAAA;AALZ;AAjBA;EA2BQ,aAAA;AAPR;AASQ;EAAA;IACI,aAAA;IACA,eAAA;IACA,WAAA;IACA,yBAAA;IACA,mBAAA;IACA,cAAA;EANV;EAAM;IASQ,eAAA;IACA,kBAAA;EANd;AACF;AAYI;EACI,oBAAA;AAVR;AASI;EAIQ,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;AAVZ;AAYY;EACI,cAAA;EACA,mBAAA;AAVhB;AAaY;EACI,yBAAA;AAXhB;AAcY;EACI,yBAAA;EACA,gBAAA;AAZhB;AAZI;EA4BY,eAAA;AAbhB;AAfI;EAgCY,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;AAdhB;AAmBY;EACI,eAAA;AAjBhB;AAgBY;EAIQ,gBAAA;AAjBpB;AAaY;EAOY,gBAAA;AAjBxB;AAqBgB;EAGQ,YAAA;AArBxB;AAkBgB;EAMY,gBAAA;AArB5B;AAgCI;EAEQ,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AA/BZ","sourcesContent":["@import '@nackle/origami/dist/less/color-vars.less';\n\n.deck-global-left-nav {\n    -webkit-font-smoothing: antialiased;\n\n    .nkl-deck-left-nav-primary {\n        opacity: 0;\n        transform: translateX(-50%);\n        transition: all 250ms ease-out;\n        font-family: Poppins, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    }\n\n    .nkl-deck-left-nav-secondary {\n        opacity: 0;\n        transform: translateX(-75%);\n        transition: all 300ms ease-out;\n    }\n\n    &.is-loaded {\n\n        .nkl-deck-left-nav-primary,\n        .nkl-deck-left-nav-secondary {\n            opacity: 1;\n            transform: translateX(0);\n            border: none;\n        }\n    }\n\n    .close-icon {\n        display: none;\n\n        @media screen and (max-width: 735px) {\n            display: flex;\n            margin-top: 6px;\n            width: 100%;\n            justify-content: flex-end;\n            margin-bottom: 11px;\n            color: #59606D;\n\n            svg {\n                cursor: pointer;\n                margin-right: 30px;\n            }\n        }\n    }\n}\n\n.nkl-deck-left-nav-primary {\n    &.ant-menu {\n        padding-bottom: 60px;\n\n        .ant-menu-item.menu-item {\n            font-size: 16px;\n            font-weight: 400;\n            border-radius: 6px;\n            margin: 0;\n            padding: 14px;\n            line-height: 24px;\n            text-transform: capitalize;\n            margin-bottom: 8px;\n\n            &.disabled {\n                color: @gray-50;\n                cursor: not-allowed;\n            }\n\n            &:hover {\n                background-color: #F5F7FA;\n            }\n\n            &.ant-menu-item-selected {\n                background-color: #F5F7FA;\n                font-weight: 700;\n            }\n\n            svg {\n                min-width: 24px;\n            }\n\n            .ant-menu-title-content {\n                overflow: hidden;\n                text-wrap: nowrap;\n                text-overflow: ellipsis;\n                display: block;\n                width: 100%;\n            }\n        }\n\n        .ant-menu-submenu-inline {\n            &.menu-item {\n                padding-left: 0;\n\n                .ant-menu-submenu-title {\n                    margin-inline: 0;\n\n                    .ant-menu-title-content {\n                        font-weight: 400;\n                    }\n                }\n\n                &.ant-menu-submenu-selected {\n                    .ant-menu-submenu-title {\n\n                        color: black;\n\n                        .ant-menu-title-content {\n                            font-weight: 700;\n                        }\n                    }\n\n                }\n            }\n        }\n    }\n}\n\n.nkl-deck-left-nav-secondary {\n    &.ant-menu {\n        .ant-menu-item.menu-item {\n            font-size: 14px;\n            line-height: 20px;\n            font-weight: bold;\n            border-radius: 4px;\n            margin: 0;\n            padding: 10px 14px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
